import { PasswordResetEnum } from "./auth/password-reset.enum";
import { DeleteAccountEnum } from "./meu-perfil/delete-account.enum";
import { ChangePasswordEnum } from "./my-profile/change-password.enum";
import { UnsavedDataSheetEnum } from "./my-profile/unsaved-data-sheet.enum";
import { DependentFormDataTestIdEnum } from "./dependents/dependent-form.enum";
import { DependentsListDataTestIdEnum } from "./dependents/dependents-list.enum";
import { ConfirmDeletionSheetEnum } from "./dependents/confirm-deletion-sheet.enum";
import { AboutUsEnum } from "./about-us/about-us.enum";
import { AppointmentsCardDataTestId } from "./appointments/appointments-card.enum";
import { AppointmentsChangePatientDataTestId } from "./appointments/appointments-change-patient.enum";
import { AppointmentsRequestCancelDataTestId } from "./appointments/appointments-request-cancel.enum";
import { AppointmentsRescheduleModalDataTestId } from "./appointments/appointments-reschedule-modal.enum";
import { AppointmentsReviewDataTestId } from "./appointments/appointments-review.enum";
import { AppointmentsTabsDataTestId } from "./appointments/appointments-tabs.enum";
import { BlogDataTestIdEnum } from "./blog/blog.enum";
import { BranchLaboratoryEnum } from "./branch-laboratory/branch-laboratory.enum";
import { BranchEnum } from "./branch/branch.enum";
import { BranchesNearYouDataTestidEnum } from "./branhes-near-you/branches-near-you.enum";
import { CitiesDataTestidEnum } from "./cities/cities.enum";
import { CityDataTestidEnum } from "./cities/city.enum";
import { UiComponentsDataTestIdEnum } from "./common/ui-components-data-test-id.enum";
import { BreadcrumbDataTestId } from "./common/breadcrumb-data-test-id.enum";
import { CalendarDataTestId } from "./common/calendar-data-test-id.enum";
import { BoundaryStateEnum } from "./common/boundary-state.enum";
import { ToastEnum } from "./common/toast.enum";
import { EntityProfileEnum } from "./common/entity-profile-data-test-id.enum";
import { FooterDataTestIdEnum } from "./common/footer-data-test-id.enum";
import { GalleryDataTestId } from "./common/gallery-data-test-id.enum";
import { HeaderDataTestIdEnum } from "./common/header-data-test-id.enum";
import { SearchProceduresModalDataTestId } from "./common/search-procedures-modal-data-test-id.enum";
import { BreadcrumbDataTestIdEnum } from "./common/ui/breadcrumb-data-test-id.enum";
import { InputDataTestIdEnum } from "./common/ui/input-data-test-id.enum";
import { SliderDataTestIdEnum } from "./common/ui/slider-data-test-id.enum";
import { SpinnerDataTestIdEnum } from "./common/ui/spinner-data-test-id.enum";
import { WorkingHoursDataTestId } from "./common/working-hours-data-test-id.enum";
import { CookiesFooterEnum } from "./cookies-footer/cookies-footer.enum";
import { EntityProcedureEnum } from "./entity-procedure/entity-procedure.enum";
import { ExamsDataTestIdEnum } from "./exams/exams.enum";
import { FaqDataTestId } from "./faq/faq-data-test-id.enum";
import { FavoritesEnum } from "./favorites/favorites.enum";
import { HomeDataTestIdEnum } from "./home/home-data-test-id.enum";
import { LocationDataTestIdEnum } from "./location/location-data-test-id.enum";
import { IndexingEnum } from "./indexing/indexing.enum";
import { LaboratoryProfileEnum } from "./laboratory/laboratory-profile.enum";
import { MarkdownTestIdEnum } from "./markdownId/markdown-test-id.enum";
import { PartnerProfileEnum } from "./partner/partner-profile.enum";
import { ServiceNetworkEnum } from "./service-network/service-network.enum";
import { WorkWithUsDataTestId } from "./work-with-us/work-with-us.datatestid";
import { LoginEnum } from "./auth/login.enum";
import { EmailIdentificationEnum } from "./auth/email-identification.enum";
import { RegisterPageEnum } from "./auth/register.enum";
import { CompleteRegistrationEnum } from "./auth/complete-registration.enum";
import { ProfileSheetTestIdEnum } from "./common/profile-sheet.enum";
import { MyProfileDataTestIdEnum } from "./my-profile/my-profile-data.enum";
import { SelectCityDataTestIdEnum } from "./common/select-city.enum";
import { SearchPageEnum } from "./search/search-page.enum";
import { SearchResultCardEnum } from "./search/search-result-card.enum";
import { SearchSortDataTestId } from "./search/search-sort.enum";
import { SearchFiltersDataTestId } from "./search/search-filters.enum";
import { NearScheduleModalEnum } from "./schedules/near-schedule-modal.enum";
import { UnavailableScheduleModalEnum } from "./schedules/unavailable-schedule-modal.enum";
import { CartDataTestIdEnum } from "./cart/cart.enum";
import { OpenPaymentsDataTestIdEnum } from "./open-payments/open-payments.enum";
import { PatientSelectionDataTestIdEnum } from "./patient-selection/patient-selection.enum";
const DataTestIdEnum = {
  ...AboutUsEnum,
  ...UiComponentsDataTestIdEnum,
  ...AppointmentsCardDataTestId,
  ...AppointmentsChangePatientDataTestId,
  ...AppointmentsRequestCancelDataTestId,
  ...AppointmentsRescheduleModalDataTestId,
  ...AppointmentsReviewDataTestId,
  ...AppointmentsTabsDataTestId,
  ...BlogDataTestIdEnum,
  ...BranchEnum,
  ...BranchesNearYouDataTestidEnum,
  ...BranchLaboratoryEnum,
  ...BreadcrumbDataTestId,
  ...BreadcrumbDataTestIdEnum,
  ...CalendarDataTestId,
  ...CitiesDataTestidEnum,
  ...CityDataTestidEnum,
  ...CookiesFooterEnum,
  ...EntityProcedureEnum,
  ...EntityProfileEnum,
  ...ExamsDataTestIdEnum,
  ...FaqDataTestId,
  ...FavoritesEnum,
  ...FooterDataTestIdEnum,
  ...GalleryDataTestId,
  ...HeaderDataTestIdEnum,
  ...HomeDataTestIdEnum,
  ...IndexingEnum,
  ...InputDataTestIdEnum,
  ...SliderDataTestIdEnum,
  ...SpinnerDataTestIdEnum,
  ...LaboratoryProfileEnum,
  ...LocationDataTestIdEnum,
  ...MarkdownTestIdEnum,
  ...PartnerProfileEnum,
  ...SearchPageEnum,
  ...SearchProceduresModalDataTestId,
  ...SearchResultCardEnum,
  ...SearchSortDataTestId,
  ...SearchFiltersDataTestId,
  ...NearScheduleModalEnum,
  ...UnavailableScheduleModalEnum,
  ...ServiceNetworkEnum,
  ...WorkingHoursDataTestId,
  ...WorkWithUsDataTestId,
  ...BoundaryStateEnum,
  ...ToastEnum,
  ...PasswordResetEnum,
  ...LoginEnum,
  ...RegisterPageEnum,
  ...CompleteRegistrationEnum,
  ...ProfileSheetTestIdEnum,
  ...MyProfileDataTestIdEnum,
  ...SelectCityDataTestIdEnum,
  ...ChangePasswordEnum,
  ...UnsavedDataSheetEnum,
  ...DeleteAccountEnum,
  ...DependentFormDataTestIdEnum,
  ...DependentsListDataTestIdEnum,
  ...ConfirmDeletionSheetEnum,
  ...CartDataTestIdEnum,
  ...OpenPaymentsDataTestIdEnum,
  ...PatientSelectionDataTestIdEnum,
  ...EmailIdentificationEnum
};
export {
  DataTestIdEnum
};
